<template>
  <div class="datepicker-wrapper">
    <ClientOnly>
      <DatePicker
        v-model:value="date"
        class="datepicker"
        type="month"
        placeholder="SELECT MONTH"
        format="MMM, YYYY"
        prefix-class="mx"
        :disabled-date="disableDate"
        :editable="false"
      >
        <template #icon-calendar>
          <i>
            <CalendarIcon />
          </i>
        </template>
      </DatePicker>
    </ClientOnly>
  </div>
</template>

<script>
import 'vue-datepicker-next/index.css';
import CalendarIcon from '~/components/Common/Svg/CalendarIcon.vue';
import { useEventsStore } from '~/stores/events';
const DatePicker = defineAsyncComponent(() => import('vue-datepicker-next'));

function toYearMonth(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export default {
  components: {
    DatePicker,
    CalendarIcon,
  },
  emits: ['setDate'],
  data() {
    return {
      date: null,
      eventsStore: useEventsStore(),
    };
  },
  watch: {
    date(date) {
      this.$emit('setDate', !date ? null : toYearMonth(date));
    },
  },
  mounted() {
    const date = this.eventsStore.date;

    if (date) {
      this.date = new Date(date);
    }
  },
  methods: {
    disableDate(date) {
      const calendarDate = toYearMonth(date);

      return !this.eventsStore.eventDates.includes(calendarDate);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './DatePicker.scss';
</style>

<style lang="scss">
@import './DatePicker.global.scss';
</style>
